module.exports = __webpack_public_path__ + "static/shoe-yellow-089664f432a379dd1cbd365685bddb64.png";